<template>
    <v-container fluid fill-height>
        <v-layout justify-center row pa-5>
            <v-flex xs12 sm10 md6>
                <v-card v-for="project in filteredProject" :key="project.location_id"
                        class="my-3"
                        style="border-left:solid 5px #0045AF;background: #e9eaeb">
                    <v-row>
                        <v-col class="text-center my-auto " cols="4">
                            <v-img class="ml-1" :src="project.image" aspect-ratio="1.7"
                                   @click="showImg(project.image)"></v-img>
                        </v-col>
                        <v-col cols="8" @click="projectSelect(project)">
                            <v-card-title><b>{{ project.location_short_name }}</b></v-card-title>
                            <v-card-text>{{ project.NT_TNAME }} ({{ project.NT_CODE }})</v-card-text>
                        </v-col>
                    </v-row>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="700">
            <v-card>
                <v-card-title>
                    <v-img :src="imageFile" height="300" aspect-ratio="1.7"></v-img>
                </v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="dialog = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import axios_box24 from '@/axios_box24'
    import EventBus from '@/EventBus'
    import axios from '@/axios';

    export default {
        name: "GetLocationBox24",
        data() {
            return {
                username: this.getLocalItem().user_id,
                projects: [],
                searchText: '',
                api_token: '',
                dialog: false,
                imageFile: ''
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'เลือกที่ตั้ง Box24', back_route: 'main-menu'});

            let localItem = this.getLocalItem();
            delete localItem.itemSelected;
            delete localItem.itemsParcel;
            delete localItem.searchText;
            localStorage.setItem('parcel', JSON.stringify(localItem))

            try {
                this.getTokenBox24().then((res) => {
                    this.api_token = res.data.data.api_token
                    this.getLocation()
                })
                    .catch(err => {
                        if (err.response) {
                            this.error.status = err.response.data.status;
                            this.error.error_code = err.response.status;
                            if (err.response.status === 401) {
                                this.error.msg = 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน Box24 ไม่ถูกต้อง'
                            } else {
                                this.error.msg = err.response.data.msg
                            }

                            console.log(this.error)
                        }
                    })
            } catch (err2) {
                console.log(err2.message)
            }

            // EventBus.$emit('setNtCode', {nt_code: localItem.NT_CODE});
        },
        methods: {
            async getLocation() {
                try {
                    axios.post('/get-location', {nt_runno: this.getLocalItem().nt_runno})
                            .then(res => {
                                console.log('getProject', res.data.data)
                                this.projects = res.data.data
                            })
                } catch (err) {
                    console.log(err.message)
                }
            },
            projectSelect(project) {
                if (project) {
                    const localItem = this.getLocalItem()
                    localItem.box24_location_short_name = project.location_short_name
                    localItem.box24_location_id = project.location_id

                    localStorage.setItem('parcel', JSON.stringify(localItem))
                    this.$router.push('size-box24')
                }
            },
            showImg(img) {
                this.imageFile = img
                this.dialog = true
            }
        },
        computed: {
            filteredProject() {
                let result = []
                let resultTmp1 = []
                let resultTmp2 = []
                let resultTmp3 = []
                if (this.searchText) {
                    resultTmp1 = this.filterObject(this.projects, 'location_name_th', this.searchText)
                    resultTmp2 = this.filterObject(this.projects, 'location_name_en', this.searchText)
                    resultTmp3 = this.filterObject(this.projects, 'location_id', this.searchText)
                    result = this.$_.sortBy(this.removeDuplicateObject(resultTmp1.concat(resultTmp2, resultTmp3)), 'location_name_th')
                } else {
                    result = this.$_.sortBy(this.projects, 'location_name_th')
                }

                return result
            }
        },
    }
</script>

<style scoped>
    .v-expansion-panel-content__wrap {
        padding: 0 6px 6px !important;
    }

    .v-card__title {
        padding: 0;
        font-size: 1em;
    }

    .v-card__text {
        padding: 0;
        color: #505a63;
        font-size: 12px;
    }

    .col-9, .col-7, .col-3, .col-2 {
        padding: 0;
    }
</style>